import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actionsGendersList from './_redux/gendersActions';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

const DropdownGenders = ({ select = undefined, selected, setSelected }) => {
    const [change, setChange] = useState(false);
    const toast = useRef(null);
    const dispatch = useDispatch();
    const { gendersList, listLoading, error } = useSelector(
        state => state.genders,
        shallowEqual
    );
    useEffect(() => {
        if (!gendersList && !error) {
            dispatch(actionsGendersList.fetchGendersList({}));
        };
    }, [gendersList, error, dispatch]);
    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Genders', detail: error });
        };
    }, [error]);
    return (
        <div>
            <Toast ref={toast} position="bottom-right" />
            {select && !change ?
                <div className="p-inputgroup">
                    <InputText value={select} disabled />
                    <Button icon="pi pi-pencil" style={{ color: 'white' }} className="p-button-warning" onClick={() => setChange(true)} type="button" />
                </div>
                :
                !gendersList && listLoading ?
                    <div className="p-d-flex p-jc-center">
                        <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="8" animationDuration="3s" />
                    </div>
                    :
                    <div className="p-d-flex p-flex-row">
                        <Dropdown className={select ? "p-col-10" : "p-col-12"} optionLabel="ds_name" optionValue="id_type_of_gender" value={selected}
                            options={gendersList}
                            onChange={(e) => setSelected(e.value)}
                            placeholder="Select a gender"
                        />
                        {select &&
                            <Button icon="pi pi-times" className="p-button-danger"
                                onClick={() => {
                                    setSelected(0);
                                    setChange(false);
                                }}
                                type="button"
                                tooltip="Cancel"
                            />
                        }
                    </div>
            }
        </div>
    )
}

export default DropdownGenders
